import type { AnyRoute } from "@tanstack/react-router";

import { createMissionsRoutes } from "./createMissionsRoutes";
import type { OperationsRouteDeps } from "./operationsRouteContext";

export type {
  OperationsRouteDeps,
  OperationsRouteFactory,
} from "./operationsRouteContext";

export function createOperationsRoutes(
  deps: OperationsRouteDeps,
): AnyRoute[] {
  return [...createMissionsRoutes(deps)];
}
